module.exports = __webpack_public_path__ + "img/bg-card-krungsri.313c0d0f.png";